<template>
  <div class="content">
    <ed-title-nav
      :title="$t('Products')"
      :subtitle="$t('Manage Products')"
      :tabs="tabs"
    ></ed-title-nav>
    <legacy-container :url="url"></legacy-container>
  </div>
</template>

<script>
  import tabs from './tabs'
  import LegacyContainer from '@/components/LegacyContainer'

  export default {
    components: {
      LegacyContainer
    },
    data() {
      return {
        tabs: tabs.tabs
      }
    },
    computed: {
      url() {
        return this.$route.params.action
      }
    },
    methods: {
      gotoTab() {
        this.$router.push(this.tabs[0].href)
      }
    },
    created() {
      this.gotoTab()
    },
    activated() {
      this.gotoTab()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Products/Products.vue